"use client";

import { IconWriteReview } from "@repo/assets/images";
import { ReviewForm } from "@repo/components";
import { Button, OffCanvasDrawer } from "@repo/ui";
import { useTranslations } from "next-intl";
import { useCallback, useState } from "react";
const ProductReview = ({
  itemId,
  session
}) => {
  const t = useTranslations("Common");
  const [openReviewForm, setOpenReviewForm] = useState(false);
  const toggleReviewDrawer = useCallback(() => {
    setOpenReviewForm(!openReviewForm);
  }, [openReviewForm]);
  return <>
      <Button size="md" variant="ghost" className="flex items-center border-none !px-0 hover:bg-white hover:underline hover:drop-shadow-none" onClick={toggleReviewDrawer} data-sentry-element="Button" data-sentry-source-file="ProductReview.jsx">
        <IconWriteReview className="me-2" data-sentry-element="IconWriteReview" data-sentry-source-file="ProductReview.jsx" />{" "}
        <span className="text-sm">{t("Write_A_Review")}</span>
      </Button>
      <OffCanvasDrawer open={openReviewForm} handleClose={toggleReviewDrawer} title={t("Rating_And_Review")} position="right" data-sentry-element="OffCanvasDrawer" data-sentry-source-file="ProductReview.jsx">
        <ReviewForm id={itemId} session={session} setOpenReviewForm={setOpenReviewForm} data-sentry-element="ReviewForm" data-sentry-source-file="ProductReview.jsx" />
      </OffCanvasDrawer>
    </>;
};
export default ProductReview;